<template>
  <div
    class="modal fade modal-progress-bar"
    id="view_progress_bar"
    ref="view_progress_bar"
    data-backdrop="static"
    role="dialog"
    aria-labelledby="view_progress_bar"
    data-test="progress-update"
  >
    <div
      class="modal-dialog modal-lg"
      role="document"
    >
      <div
        class="modal-content border-0"
        ref="section"
      >
        <div class="border-bottom border-bottom-1 modal-header py-2" data-test="section-progress-title">
          <h6 class="modal-title" data-test="progress-title">
            {{ getTitle() }}
          </h6>
          <div class="text-muted " data-test="progress-get-time">
            {{ $t('_progress.Last Updated') }}: {{ getTime() }}
          </div>
        </div>
        <div class="modal-body p-0" data-test="section-progress-body">
          <div class="d-flex align-items-center p-3">
            <div
              :class="[productLinkList.progress < 100 ? 'rotate' : '']"
              class="
                mr-3
                rounded-round
                d-flex
                align-items-center
                justify-content-center
                p-2
                border-2 border-primary
                text-primary
              "
              style="width: 50px; height: 50px"
            >
              <i class="fa-solid fa-hourglass-half fa-2x" />
            </div>
            <div
              style="width: calc(100% - 100px);">
              <div 
                class="progress rounded-round mb-2" 
                style="height: 12px"
              >
                <div
                  class="progress-bar bg-primary rounded-round"
                  :style="`width:${productLinkList.progress}%;`"
                />
              </div>
              <div>
                {{ getTitle() }}
              </div>
            </div>
          </div>
          <span class="d-flex px-3 pb-3 text-primary">{{ $t('Response Message') }}</span>
          <div class="content-progress-bar px-3 overflow-scroll">
            <div 
              v-for="(group, channelId) in groupedData" 
              :key="channelId" 
              class="items-progress-bar mb-1 pb-1"
              data-test="section-item-progress-bar"
            >
              <div 
                v-for="(item, j) in group"
                :key="'list'+j"
                class="item pb-2"
              >
                <div class="top-channel d-flex mb-2">
                  <div class="mr-2">
                    <img
                      v-if="(item.channel_logo && item.platform != 'Partner') || item.channel_id != 'manual'"
                      :src="getUrlImage(item)"
                      class="image_box rounded"
                      style="cursor: pointer;"
                    >
                    <img
                      v-else
                      :src="$storeIndex.getImageGobalAssets('icon-gosell')"
                      class="image_box rounded"
                    >
                  </div>
                  <div><span>{{ item.channel_name }}</span></div>
                </div>
                <div class="d-flex px-3 vertical-align-top" data-test="item-progress-bar">
                  <div class="d-flex w-60 pr-3" data-test="progress-item-name">
                    <i class="fas fa-angle-right mr-2 mt-1" />
                    <div class="mr-2">
                      <img
                        v-if="item.image"
                        :src="item.image"
                        class="image_box rounded"
                        style="cursor: pointer;"
                      >
                      <img
                        v-else
                        :src="$storeIndex.getImageGobalAssets('')"
                        class="image_box rounded"
                      >
                    </div>
                    <div class="word-break">
                      <ProductNameComponent
                        :product-name="item.product_name"
                        :product-sku="getSku(item)"
                        :link-active="false"
                      />
                    </div>
                  </div>
                  <div 
                    v-if="getLastUpdate(item.model_external_id).product_id"
                    :class="['d-flex flex-column', getLastUpdate(item.model_external_id).status ? 'text-success' : 'text-danger']"
                    data-test="progress-item-status"
                    >
                    <div v-if="getLastUpdate(item.model_external_id).status">
                      <span><i class="fas fa-circle-check" />
                        {{ $t('_progress.Update Salable') }} 
                        <span 
                          v-if="getLastUpdate(item.model_external_id).qty"
                          class="font-weight-bold"
                        >
                          {{ getLastUpdate(item.model_external_id).qty }}
                        </span>
                        {{ $t('_progress.QTY Success') }} </span>
                    </div>
                    <div v-else>
                      <span><i class="fas fa-circle-exclamation" /> {{ $t(getLastUpdate(item.model_external_id).message) }}</span>
                    </div>
                    <div 
                      v-if="getLastUpdate(item.model_external_id).request_id" 
                      class="text-muted"
                    >
                      {{ $t('Request ID') }}: {{ getLastUpdate(item.model_external_id).request_id }}
                    </div>
                  </div>
                  <div v-else>
                    <span class="text-muted"><i class="fas fa-spinner fa-spin" /> {{ $t('Updating') }}...</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-center bg-light py-2">
          <div class="d-flex justify-content-between">
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              aria-label="Close"
              @click="closeModal()"
              :disabled="productLinkList.progress < 99"
              data-test="btn-got-it-progress"
            >
              <i class="fa-solid fa-circle-check mr-1" />{{ $t('Got It') }}!
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductNameComponent from '@/components/tenancy/center/ProductNameComponent.vue';
import moment from "moment";
import { convertTimezone } from "@/common/tenancy/convertTimezone.js";
window.Pusher = require('pusher-js');
import Cookies from "js-cookie";
export default {
  props: {
    isShowProgressBar: {
      type: [Boolean],
      default: false
    },
    listItemProductLink:{
      type: [Object, Array],
      default: undefined
    }
  },
  components: {
    ProductNameComponent
  },
  data() {
    return {
      tenant: JSON.parse(Cookies.get('tenant')),
      isShowModal: false,
      productLinkList: {
        'progress' : 0,
        'items' : [],
      },
      itemList : [],
      groupedData:[],
    };
  },
  mounted() {
    this.addObjectData();
    this.isShowComponent();
    this.openWebsocket();
      var vm = this;
      setTimeout(function(){
      vm.isShow = true;
    }, 5000);
    this.groupByChannelId(this.listItemProductLink);
  },
  watch: {
  },
  methods: {
    getTitle(){
      return (this.productLinkList.progress >= 100) ? this.$t('Updated product successfully') : this.$t('Updating Product');
    },
    getUrlImage(image){
      if(image){
        return image.channel_logo ? image.channel_logo : image.image_channel;
      }
    },
    getSku(data){
      if(data){
        return data.sku  ? data.sku : null;
      }
    },
    addObjectData(){
      this.listItemProductLink.items.forEach(obj => {
        obj.status_progress = [];
      });
    },
    getTime(){
      let toDay = new Date();
      return moment(convertTimezone.utcToLocal(toDay)).format('YYYY-MM-DD HH:mm:ss');
    },
    getLastUpdate(itemId){
      let findId = this.productLinkList.items.find(item => item.product_id == itemId);
      let socketDataItem = {
        "request_id" : '',
        "qty" : '',
        "message" : '',
        "status" : false,
        "id" : '',
        "product_id" : "",
      };
      if(findId){
        let messageData = findId.message;
        if(!findId.status){
          messageData = this.$t('Update Failed')+ ' - (' + this.$t(findId.message) + ')';
        }

        socketDataItem = {
          "request_id" : findId.request_id,
          "qty" : findId.qty,
          "message" : messageData,
          "status" : findId.status,
          "id" : findId.id,
          "product_id" : findId.product_id,
        };
      }
      return socketDataItem;
    },
    groupByChannelId(data){
      this.groupedData = data.items.reduce((acc, obj) => {
        const channelId = obj.channel_id;
        if (!acc[channelId]) {
          acc[channelId] = [];
        }
        acc[channelId].push(obj);
        return acc;
      }, {});
    },
    isShowComponent(){
      this.$nextTick(() => {
        $('#view_progress_bar').modal('show');
      });   
    },
    closeModal(){
      // let data = false;
      this.closeProgress();
      // this.$emit('hideModalProgressBar', data);

      this.$store.dispatch('product/isFeedDataProduct', false);
      this.$store.dispatch('product/isFeedDataProductList', false);
      this.$nextTick(() => {
        this.$store.dispatch('product/isFeedDataProduct', true);
        this.$store.dispatch('product/isFeedDataProductList', true);
      });
      $('#view_progress_bar').hide('show');
    },
    closeProgress() {
      if (!localStorage.getItem('isCypress')) {
        if (this.websocket) {
            this.websocket.close();
        }
      }

      this.$store.dispatch("product/isOpenModal", true);
      this.$nextTick(() => {
          this.$store.dispatch("product/isOpenModal", false);
      });

    },
    getCurrentTime() {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); 
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    openWebsocket(){
      let vm = this;
      let ws = this.websocket = new WebSocket(process.env.WEBSOCKETS_GOQUEUE_URL);
      const tenant = this.tenant;
      if(localStorage.getItem('isCypress')){
        let dataWebsocket = JSON.parse(localStorage.getItem('cypressDataWebsocket'));
            if (dataWebsocket) {
              dataWebsocket.forEach(data => {
                let dataOnmessage = JSON.parse(JSON.stringify(data)) 
                vm.websocketOnMessage(dataOnmessage , tenant);
              }); 
            } 
      } else {
        ws.onopen = function open() {
          console.log('onopen')
          ws.send(JSON.stringify({
          "data": {
              "clientUid": `request.product.link${tenant.id}`
          },
          "event": "subscribe"
          }));
      };
      ws.onmessage = function incoming(message) {
        let dataOnmessage = JSON.parse(message.data)    
        vm.websocketOnMessage(dataOnmessage , tenant); 
      }
        
      }
    },

    websocketOnMessage (data , tenant) {
      let vm = this;
      let ws = this.websocket = new WebSocket(process.env.WEBSOCKETS_GOQUEUE_URL);
      if (data.event == `request.product.link`) {
          if(data.data.clientUid == `request.product.link${tenant.id}`){  
            let items = data.data;
            if (!items.hasOwnProperty('product_id')) {
                return
            }

            let info = {
              'id' : items.product_link_id,
              'name' : items.product_link_name,
              'total' : items.saleable_qty,
              'progress' : ((1 / items.product_link_item_total) * 100),
              'items' : [
                {
                  "request_id" : items.request_id,
                  "qty" : items.saleable_qty,
                  "message" : items.message,
                  "status" : items.status,
                  "id" : items.product_link_item,
                  "product_id" : items.product_id,
                }
              ]
            }

            let html = ""
            $(`#${items.product_link_item}`).text(items.saleable_qty)
            if(items.status){
              html = '<span class="badge bg-success-400 px-2"><i class="fa-solid fa-check-circle mr-2" />'+vm.$t("_link.Updated")+'</span>'
              $(`#status-${items.product_link_item}`).html(html)
            }

            if(!items.status){
              html = '<span class="badge bg-danger-400 px-2"><i class="fa-solid fa-exclamation-triangle mr-2" />'+vm.$t("_link.Failed")+'</span>'
              $(`#status-${items.product_link_item}`).html(html)
            }

            $(`#request-id-${items.product_link_item}`).html(vm.$t('Request ID') + ' : ' +items.request_id)
            $(`#message-${items.product_link_item}`).html(vm.$t('Message') + ' : ' +items.message)
            $(`#qty-${items.product_link_item}`).html(vm.$t('Salable QTY') + ' : ' +items.saleable_qty)
            $(`.view-qty`).html(items.saleable_qty)
            $(`#time-${items.product_link_item}`).html(vm.$t('Last Updated') + ' : ' +vm.getCurrentTime())

            if(vm.productLinkList.items.length){
              let item = {
                  "name" : items.product_name,
                  "request_id" : items.request_id,
                  "qty" : items.saleable_qty,
                  "message" : items.message,
                  "status" : items.status,
                  "id" : items.product_link_item,
                  "product_id" : items.product_id,
              }
              vm.productLinkList.items.push(item)    
            }else{
              vm.productLinkList = info;
            }
          }
          if(data.data.clientUid == `request.product.link${tenant.id}` && data.event === 'ping') {
            ws.send(JSON.stringify({
              "data": {
                "clientUid": `request.product.link${tenant.id}`
              },
              "event": `pong`
            }))
          }
          vm.productLinkList.progress = ((vm.productLinkList.items.length / vm.listItemProductLink.items.length) * 100)
           
          if(vm.productLinkList.progress >= 100){
            vm.$store.dispatch("product/syncStockProgress", false);
            vm.$nextTick(() => {
              vm.$store.dispatch("product/syncStockProgress", true);
            });
            vm.websocket.close();
          }

        }
    },
  }
}
</script>
<style scoped>
.fade {
    pointer-events: none !important;
}
.modal + .modal.modal-progress-bar {
    z-index: 1099;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/center/ProgressBarPopUpComponent.vue